<script lang="ts" setup>
import ModalComponent from '@/components/ModalComponent.vue'
import FeedbackSurvey from '@/components/survey/FeedbackSurvey.vue'
import { onMounted, ref } from 'vue'
import { api } from '@/services/ApiService.ts'
import userStore from '@/store/UserStore.ts'

defineEmits(['confirmClicked', 'cancelClicked', 'closeClicked'])

const shouldShowSurvey = ref(false)

onMounted(async () => {
  if (!!userStore.feedbackSurveyLink &&
    userStore.feedbackSurveyLink.trim() !== '' && userStore.feedbackSurveyFrequency !== 0) {

    try {
      shouldShowSurvey.value = await api.shouldShowFeedbackSurvey()
    } catch (error) {
      console.error('Failed to fetch survey visibility:', error)
    }
  }
})

</script>

<template>
  <ModalComponent
    :has-controls="true"
    :is-closable="true"
    class="is--status"
    @cancel="$emit('cancelClicked')"
    @close="$emit('closeClicked')"
    @confirm="$emit('confirmClicked')"
  >
    <template #title>
      <div class="modal__icon">
        <i class="ic-check" />
      </div>
      {{ $t('modal.simulation_title') }}
    </template>
    <template #text>
      <span v-sanitize-html="$t('modal.simulation_successful_text')" />
    </template>
    <template #confirm>
      {{ $t('overview.btn_create') }}
    </template>
    <template #cancel>
      {{ $t('global.btn_back_to_overview') }}
    </template>
    <template v-if="shouldShowSurvey" #survey>
      <FeedbackSurvey
        @close-clicked="$emit('closeClicked')"
      />
    </template>
  </ModalComponent>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

:deep(.modal__box) {
  @include media('<tablet') {
    padding: 1rem;
  }
}

:deep(.modal__btns) {
  margin-top: 1rem;

  @include media('<tablet') {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 6rem;
    padding: 1rem;
    white-space: nowrap;
  }

  .btn {
    @include media('<tablet') {
      margin-top: 1rem;
      margin-right: 0;
    }

    .is--secondary {
      @include media('<tablet') {
        margin-top: 1rem;
      }
    }
  }
}

:deep(.modal__icon) {
  margin: 1rem auto 1rem auto;
}

:deep(.modal__text) {
  margin: 0;
}
</style>
